// src/pages/Settings.js
import React from 'react';
import { Box, Typography } from '@mui/material';

export default function Settings() {
  return (
    <Box>
      <Typography variant="h5" sx={{ mb: 2 }}>
        Settings
      </Typography>

      <Typography variant="body1">
        Settings page placeholder.  
        Add configuration options here such as SMS numbers, reminder rules, and admin preferences.
      </Typography>
    </Box>
  );
}
